import React, { useState } from 'react'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import CryptoTrackers from './components/CryptoTrackers'
import NotFound from './components/NotFound'
import Navbar from './components/Navbar'
import { Box, createTheme, ThemeProvider } from '@mui/material'

const App = () => {

  const [theme,setTheme] = useState('dark')
  const darkTheme = createTheme({
    palette:{
      mode: theme
    }
  })
  return (
    <ThemeProvider theme={darkTheme}>
      <Box bgcolor={'background.default'} color={'text.primary'}>
        <BrowserRouter>
        <Navbar theme={theme} setTheme={setTheme} />
        <Routes>
          <Route path='/' element={<CryptoTrackers />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
        </BrowserRouter>
      </Box>
    </ThemeProvider>
  )
}

export default App